import { UndoAction } from './Action';
import { UPDATE_NAME } from '../../../graphql/shopping-list';

/* eslint-disable no-underscore-dangle */

export default class UpdateNameAction extends UndoAction {
  constructor(options) {
    super(options);

    this.value = options.value;
    this.origName = this.component.shoppingList.name.slice();
  }

  static get name() { return 'UpdateNameAction'; }

  _executeImpl() {
    const self = this;

    return this.component.$apollo.mutate({
      mutation: UPDATE_NAME,
      variables: {
        id: this.component.shoppingList.id,
        name: this.value,
      },
      update(store, { data: { shoppingListUpdateName } }) {
        self._updateCache(store, shoppingListUpdateName);
      },
      optimisticResponse() {
        const shoppingListUpdateName = {
          __typename: 'ShoppingListUpdateName',
          id: self.component.shoppingList.id,
          name: self.value,
          modifiedAt: null,
        };

        return { shoppingListUpdateName };
      },
    });
  }

  // eslint-disable-next-line
  updateQuery(cachedShoppingList, shoppingListUpdateName) {
    cachedShoppingList.name = shoppingListUpdateName.name;
    return cachedShoppingList;
  }

  undo() {
    return this.component.triggerAction(UpdateNameAction, {
      value: this.origName,
      undoAction: this,
    });
  }

  // eslint-disable-next-line
  undoTooltip() { return 'Undo change name'; }

  // eslint-disable-next-line
  redoTooltip() { return 'Redo change name'; }
}



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/UpdateNameAction.js